import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import TeamSection from './components/TeamSection';
import WaitlistSection from './components/WaitlistSection';
import SEOHead from '../../components/SEOHead';

export default function HomePage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${import.meta.env.VITE_SITE_URL}/#organization`,
        "name": "Flyte",
        "url": import.meta.env.VITE_SITE_URL,
        "logo": {
          "@type": "ImageObject",
          "url": "https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/adb892c307ccd99e85b52fe2d4c92656.jfif"
        },
        "description": "AI-powered flight disruption prediction technology that alerts travelers 36+ hours before airlines do.",
        "foundingDate": "2024",
        "founder": [
          {
            "@type": "Person",
            "name": "Sofia Naumovski"
          }
        ],
        "sameAs": [
          "https://www.linkedin.com/company/flyte-travel"
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${import.meta.env.VITE_SITE_URL}/#website`,
        "url": import.meta.env.VITE_SITE_URL,
        "name": "Flyte - Travel Without What-Ifs",
        "description": "AI-powered flight disruption prediction that gives you the advantage to move first with personalized travel alternatives.",
        "publisher": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
        }
      },
      {
        "@type": "WebPage",
        "@id": `${import.meta.env.VITE_SITE_URL}/#webpage`,
        "url": import.meta.env.VITE_SITE_URL,
        "name": "Flyte - Travel Without What-Ifs | AI-Powered Flight Disruption Prediction",
        "isPartOf": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#website`
        },
        "about": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
        },
        "description": "Flyte uses AI to predict flight delays and cancellations 36+ hours before airlines do. Get early access to personalized travel alerts and alternatives."
      },
      {
        "@type": "SoftwareApplication",
        "name": "Flyte",
        "description": "AI-powered travel intelligence platform that predicts flight disruptions and provides personalized alternatives.",
        "url": import.meta.env.VITE_SITE_URL,
        "operatingSystem": "Web",
        "applicationCategory": "TravelApplication",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD",
          "availability": "https://schema.org/ComingSoon"
        },
        "author": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
        }
      }
    ]
  };

  return (
    <div className="min-h-screen">
      <SEOHead structuredData={structuredData} />
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <TeamSection />
      <WaitlistSection />
      <Footer />
    </div>
  );
}
